import httpResource from "@/components/infrastructures/functions/http/httpResource";
import {accountEmailToSend} from "@/components/domains/auth/authPolicy";

/** Adds `email` only when one was entered, so a blank field sends today's body. */
function withEmail<T extends Record<string, string>>(data: T, email?: string): T & { email?: string } {
    const value = accountEmailToSend(email || '');
    return value === undefined ? data : Object.assign({}, data, {email: value});
}

export default class AccountService {

    public static async registerEnterpriseAccount(agencyName: string, username: string, password: string, verifyPassword: string, email?: string) {
        const data = withEmail({
            agencyName: agencyName,
            username: username,
            password: password,
            verifyPassword: verifyPassword,
        }, email);
        return (await httpResource.post('/account/register/enterprise', data)).data;
    }

    public static async registerStudioAccount(studioId: string, username: string, password: string, verifyPassword: string, email?: string) {
        const data = withEmail({
            studioId: studioId,
            username: username,
            password: password,
            verifyPassword: verifyPassword,
        }, email);
        return (await httpResource.post('/account/register/studio', data)).data;
    }
}